{
  "$schema": "./schema.json",
  "applicationPreview": {
    "heading": "Review and submit",
    "pageTitle": "Your application",
    "bidSelected": {
      "subheading": "Your application"
    },
    "nonDraft": {
      "heading": "Your application"
    },
    "submitCta": "Submit application",
    "continueAndReceiveOffersCta": "Continue and receive offers",
    "showOffersCta": "Show offers",
    "backToOffersCta": "Back to offers",
    "backCta": "Back",
    "mostImportantInformationHeading": "Most important information",
    "financialInformation": {
      "heading": "Financial information",
      "subtitle": "Add financial reports and forecasts"
    },
    "collateralInformation": {
      "heading": "Collateral information",
      "subtitle": "Add information about collateral"
    },
    "repayment": {
      "heading": "Loan Repayment",
      "subtitle": "Add a plan for repayment of loan"
    },
    "additionalFinancingOffers": "Additional financing offers",
    "additionalFinancingOffersExplainer": "To also get factoring, leasing or real estate loan offers, fill in the required information below.",
    "additionalFinancingOffersQuestionsAnswered": "{{outOf}} questions answered",
    "factoringOffersHeading": {
      "title": "Sell your invoices",
      "subtitle": "Get paid today (up to 100% of the invoiced value)"
    },
    "leasingOffersHeading": {
      "title": "Lease equipment or machines",
      "subtitle": "You generally get a lower monthly cost"
    },
    "realEstateOffersHeading": {
      "title": "Finance with real estate as collateral",
      "subtitle": "Give collateral in private or business property to access lower rates"
    },
    "steps": {
      "nextStep": "Next step",
      "common": {
        "reviewAndSubmit": "Review and submit",
        "creditCheck": "We prepare your file - only one credit check is made on your company and provided guarantors",
        "improveApplication": "We analyse the application to ensure you get the best terms",
        "receiveFunds": "Choose the best offer and receive funds"
      }
    },
    "popup": {
      "title": {
        "loading": "Thank you, nearly there...",
        "applicationSent": "Application submitted",
        "applicationDigitalAdvice": "Below you can see improvements we identified for your application.",
        "applicationAdvice": "Your business qualifies for free personal advisory.",
        "applicationNotSent": "Application not yet submitted"
      },
      "preloader": "We analyse your request and prepare your credit file"
    },
    "strengthenApplicationHeading": "Strengthen your application",
    "recommended": "Recommended",
    "optional": "Optional",
    "required": "Required",
    "whatHappensNext": {
      "title": "What happens next?",
      "description": "Only one credit check is made on your company and provided guarantors and your file will be sent to lenders. The more information you provide, the more likely you are to get better offers."
    },
    "companyInformation": "Company information",
    "companyName": "Company name",
    "organisationNumber": "Organisation number",
    "contactDetails": "Contact details",
    "contactPerson": "Contact person",
    "phoneNumber": "Phone number",
    "applicationStatus": "Application status",
    "done": "Completed",
    "fieldsLeft": "{{count}} left",
    "submit": {
      "title1": "Preparing your file...",
      "title2": "Analysing your application...",
      "titleDone": "We analysed your application",
      "continueWithoutImprovements": "Continue without improvements",
      "digitalAdvice": {
        "description": "We found {{count}} improvements - it only takes 2-3 minutes",
        "descriptionOne": "We found 1 improvement - it only takes 2-3 minutes",
        "cta": "See improvements"
      },
      "revenueAdvice": {
        "description": "You could get better offers by adding recent sales information - it only takes 2-3 minutes to add",
        "cta": "Add recent sales information"
      },
      "manualAdvice": {
        "description": "You can get better terms through our advisory service",
        "cta": "Continue to advisory service"
      }
    },
    "support": {
      "ctaText": "Need help?",
      "previewContactPersonMessage": "<b>Need help with your application?</b><br/>  Call {{firstName}}, your assigned advisor: <a>{{mobilePhoneNumber}}</a>"
    },
    "showMore": "Show more",
    "showLess": "Show less"
  }
}
